import { Pie } from 'vue-chartjs';

import { STATUS } from './constants';

export default {
  extends: Pie,
  props: {
    aggs: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (!this.aggs) {
      return;
    }
    const data = [this.aggs.queued || 0, this.aggs.requeued || 0, this.aggs.inprogress || 0, this.aggs.failed || 0, this.aggs.completed || 0];

    const labels = Object.values(STATUS).map(({ label }) => label);
    const colors = Object.values(STATUS).map(({ color }) => color);

    this.renderChart(
      {
        datasets: [
          {
            data,
            backgroundColor: colors,
            borderWidth: 0
          }
        ],
        labels: labels
      },
      {
        responsive: true,
        maintainAspectRatio: false
      }
    );
  }
};
